/** Strip HTML and legacy "Message: … Context: …" wrappers from stored user turns. */
export function plainUserText(raw: string): string {
  const noHtml = raw.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  const messageMatch = noHtml.match(/^Message:\s*(.+?)(?:\.\s*Context:|$)/is);
  if (messageMatch?.[1]) return messageMatch[1].trim();
  return noHtml;
}
